<template>
  <q-header elevated class="text-white header">
    <q-toolbar class="header__toolbar">
      <q-btn
        dense
        flat
        round
        icon="menu"
        class="toggleMenuBtn"
        @click.prevent="$emit('toggle-navbar')"
      />
      <q-toolbar-title
        class="logo"
        style="display: flex; align-items: center; gap: 40px;"
      >
        <router-link to="/">
          <img
            src="@/assets/img/logo.png"
            class="logo__img"
            alt="logo_picture"
          />
          <img
            src="@/assets/img/logo_small.png"
            class="logo__img logo__img_mobile"
            alt="logo_picture"
          />
        </router-link>
        <CityBlock header />
      </q-toolbar-title>
      <div class="header__right">
        <div class="row items-center no-wrap">
          <q-btn
            class="mobile-app-btn"
            dense
            no-caps
            flat
            icon="smartphone"
            label="Скачать приложение"
            @click="openMobileApp"
          />
          <div class="userbox__wrapper">
            <q-icon name="fa-solid fa-circle-user" class="userbox__icon" />
            <div style="display: flex; flex-direction: column;">
              <div class="userbox">
                {{ userData?.fio || 'Пользователь' }}
              </div>
              <span
                v-if="userData?.position_name"
                class="userbox__desc"
                >{{ userData?.position_name || '' }}</span
              >
            </div>
            <q-icon
              name="fas fa-chevron-down"
              style="font-size: 12px; color: #fff;"
            />
            <q-menu fit anchor="bottom left" self="top start">
              <q-item v-if="ssoEnabled && ssoLink" class="list__item">
                <SsoLinkButton
                  :dest="ssoLink.dest"
                  :label="ssoLink.label"
                  :icon="ssoLink.icon || 'fa-solid fa-arrow-up-right-from-square'"
                  variant="link"
                  block
                  class="list__item_content sso-menu-link"
                  @error="onSsoError"
                />
              </q-item>
              <q-item clickable class="list__item">
                <router-link to="/profile">
                  <div class="list__item_content">
                    <div class="tw-w-5 tw-flex tw-justify-center tw-items-center">
                      <img src="@/assets/img/icons/user.svg" class="tw-w-5" />
                    </div>
                    Профиль
                  </div>
                </router-link>
              </q-item>
              <q-item clickable class="list__item">
                <div @click="handleLogout" class="list__item_content logout">
                  <div class="tw-w-5 tw-flex tw-justify-center tw-items-center">
                    <img src="@/assets/img/icons/logout.svg" />
                  </div>
                  Выйти
                </div>
              </q-item>
            </q-menu>
          </div>
        </div>
      </div>
    </q-toolbar>
  </q-header>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { Notify } from 'quasar'
import { useAppStore } from '@/services/store/app'
import CityBlock from '@/components/features/cityBlock'
import { MODAL_NAMES } from '@/constants'
import { storeToRefs } from 'pinia'
import { fetchSsoConfig } from '@/services/keycloakSso'
import { SSO_LINKS } from '@/config/ssoLinks.config'
import SsoLinkButton from '@/components/common/SsoLinkButton.vue'

const appStore = useAppStore()
const { userData } = storeToRefs(appStore)

const ssoEnabled = ref(false)
const ssoLink = ref(SSO_LINKS[0] || null)

onMounted(async () => {
  const cfg = await fetchSsoConfig()
  ssoEnabled.value = !!cfg.enabled
})

function onSsoError() {
  Notify.create({
    type: 'negative',
    position: 'bottom-left',
    timeout: 8000,
    message: 'Переход доступен только при входе через BI Group. Авторизуйтесь через BI Group.',
  })
}

function openMobileApp() {
  appStore.showModal(MODAL_NAMES.MobileAppPromo, {
    title: 'Мобильное приложение Smart Build System',
    wide: true,
    confirmUnsavedClose: false,
  })
}

function handleLogout() {
  appStore.logout()
}
</script>

<style lang="scss">
.toggleMenuBtn {
  .q-icon {
    color: #fff
  }
}
.header {
  .q-layout__shadow {
    &::after {
      box-shadow: none;
    }
  }
}
</style>

<style scoped lang="scss">
.logo {
  & > a {
    display: flex;
    align-items: center;
    width: fit-content;
  }

  &__img {
    height: 30px;

    @media (max-width: 576px) {
      height: 25px;
    }

    @media (max-width: 400px) {
      display: none;
    }

    &_mobile {
      display: none;

      @media (max-width: 400px) {
        display: block;
      }
    }
  }
}

.header {
  box-shadow: 0px 5px 15px 0px #0000000D;
  background-color: #152957;

  &__toolbar {
    @media (max-width: 576px) {
      padding: 0 5px;
    }
  }

  &__right {
    display: flex;
    gap: 15px;
  }
}

.userbox {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 16px ;
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  color: #fff;

  @media (max-width: 360px) {
    max-width: 65px;
    text-overflow: ellipsis;
  }

  @media (max-width: 320px) {
    display: none;
  }

  &__wrapper {
    height: 50px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      background-color: #1d356d;
    }
  }

  &__icon {
    font-size: 27px;
    color: #D1D5DB;
  }
  &__desc {
    font-size: 12px;
    line-height: 12px;
    color: #9CA3AF;
    @media (max-width: 320px) {
      display: none;
    }
  }
}

.mobile-app-btn {
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 8px;
  color: #fff;
  margin-right: 6px;
  font-weight: 600;
  min-height: 34px;
  padding: 0 10px;

  @media (max-width: 900px) {
    display: none;
  }
}

@media (max-width: 576px) {
  .logo {
    & > img {
      display: none;
    }
  }
}

.list {
  &__item {
    padding: 0;
    width: 100%;
    min-height: auto;

    a {
      height: 100%;
      width: 100%;
    }

    &_content {
      width: 100%;
      height: 100%;
      display: flex;
      padding: 10px;
      align-items: center;
      gap: 8px;

      &.logout {
        font-weight: 500;
      }
    }
  }

  &__item .sso-menu-link {
    justify-content: flex-start;
    color: #1f2937;
    font-weight: 500;
    padding: 10px;
    border-radius: 0;
  }

  &__item .sso-menu-link:hover {
    background: #f1f5f9;
    text-decoration: none;
  }
}
</style>
